/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GoogleCalendarAuthSuccessRouteImport } from './routes/googleCalendarAuthSuccess'
import { Route as GoogleCalendarAuthErrorRouteImport } from './routes/googleCalendarAuthError'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as UnauthenticatedIndexRouteImport } from './routes/_unauthenticated/index'
import { Route as UnauthenticatedResetPasswordRouteImport } from './routes/_unauthenticated/reset-password'
import { Route as UnauthenticatedOnboardingRouteImport } from './routes/_unauthenticated/onboarding'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedForgotPasswordRouteImport } from './routes/_unauthenticated/forgot-password'
import { Route as AuthenticatedLogoutRouteImport } from './routes/_authenticated/logout'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedTablesIndexRouteImport } from './routes/_authenticated/tables/index'
import { Route as AuthenticatedSummarizationsIndexRouteImport } from './routes/_authenticated/summarizations/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedJournalIndexRouteImport } from './routes/_authenticated/journal/index'
import { Route as AuthenticatedInsightsIndexRouteImport } from './routes/_authenticated/insights/index'
import { Route as AuthenticatedCalendarIndexRouteImport } from './routes/_authenticated/calendar/index'
import { Route as AuthenticatedSettingsWeekRouteImport } from './routes/_authenticated/settings/week'
import { Route as AuthenticatedSettingsPhysicalCapacityRouteImport } from './routes/_authenticated/settings/physical-capacity'
import { Route as AuthenticatedSettingsLifeSatisfactionRouteImport } from './routes/_authenticated/settings/life-satisfaction'
import { Route as AuthenticatedSettingsLifeBalanceRouteImport } from './routes/_authenticated/settings/life-balance'
import { Route as AuthenticatedSettingsLabelsRouteImport } from './routes/_authenticated/settings/labels'
import { Route as AuthenticatedSettingsCalendarRouteImport } from './routes/_authenticated/settings/calendar'
import { Route as AuthenticatedHabitsNewRouteImport } from './routes/_authenticated/habits/new'
import { Route as AuthenticatedGoalsCreateRouteImport } from './routes/_authenticated/goals/create'
import { Route as AuthenticatedSettingsLabIndexRouteImport } from './routes/_authenticated/settings/lab/index'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/index'
import { Route as AuthenticatedGoalsGoalIdIndexRouteImport } from './routes/_authenticated/goals/$goalId/index'
import { Route as AuthenticatedTasksNewFormRouteImport } from './routes/_authenticated/tasks/new/form'
import { Route as AuthenticatedTasksTaskIdFocusRouteImport } from './routes/_authenticated/tasks/$taskId/focus'
import { Route as AuthenticatedTasksTaskIdEditRouteImport } from './routes/_authenticated/tasks/$taskId/edit'
import { Route as AuthenticatedTasksTaskIdDetailRouteImport } from './routes/_authenticated/tasks/$taskId/detail'
import { Route as AuthenticatedProjectsNewFormRouteImport } from './routes/_authenticated/projects/new/form'
import { Route as AuthenticatedProjectsProjectIdEditRouteImport } from './routes/_authenticated/projects/$projectId/edit'
import { Route as AuthenticatedJournalNewFormRouteImport } from './routes/_authenticated/journal/new/form'
import { Route as AuthenticatedJournalJournalIdEditRouteImport } from './routes/_authenticated/journal/$journalId/edit'
import { Route as AuthenticatedJournalJournalIdDetailRouteImport } from './routes/_authenticated/journal/$journalId/detail'
import { Route as AuthenticatedHabitsHabitIdEditRouteImport } from './routes/_authenticated/habits/$habitId/edit'
import { Route as AuthenticatedGoalsGoalIdRefineRouteImport } from './routes/_authenticated/goals/$goalId/refine'
import { Route as AuthenticatedCalendarNewFormRouteImport } from './routes/_authenticated/calendar/new/form'
import { Route as AuthenticatedCalendarEntryIdEditRouteImport } from './routes/_authenticated/calendar/$entryId/edit'
import { Route as AuthenticatedSettingsLabelsLabelIdModalRouteImport } from './routes/_authenticated/settings/labels/$labelId/modal'

const GoogleCalendarAuthSuccessRoute =
  GoogleCalendarAuthSuccessRouteImport.update({
    id: '/googleCalendarAuthSuccess',
    path: '/googleCalendarAuthSuccess',
    getParentRoute: () => rootRouteImport,
  } as any)
const GoogleCalendarAuthErrorRoute = GoogleCalendarAuthErrorRouteImport.update({
  id: '/googleCalendarAuthError',
  path: '/googleCalendarAuthError',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedIndexRoute = UnauthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedResetPasswordRoute =
  UnauthenticatedResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedOnboardingRoute =
  UnauthenticatedOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedForgotPasswordRoute =
  UnauthenticatedForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedLogoutRoute = AuthenticatedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTablesIndexRoute =
  AuthenticatedTablesIndexRouteImport.update({
    id: '/tables/',
    path: '/tables/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSummarizationsIndexRoute =
  AuthenticatedSummarizationsIndexRouteImport.update({
    id: '/summarizations/',
    path: '/summarizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalIndexRoute =
  AuthenticatedJournalIndexRouteImport.update({
    id: '/journal/',
    path: '/journal/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInsightsIndexRoute =
  AuthenticatedInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarIndexRoute =
  AuthenticatedCalendarIndexRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsWeekRoute =
  AuthenticatedSettingsWeekRouteImport.update({
    id: '/settings/week',
    path: '/settings/week',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsPhysicalCapacityRoute =
  AuthenticatedSettingsPhysicalCapacityRouteImport.update({
    id: '/settings/physical-capacity',
    path: '/settings/physical-capacity',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsLifeSatisfactionRoute =
  AuthenticatedSettingsLifeSatisfactionRouteImport.update({
    id: '/settings/life-satisfaction',
    path: '/settings/life-satisfaction',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsLifeBalanceRoute =
  AuthenticatedSettingsLifeBalanceRouteImport.update({
    id: '/settings/life-balance',
    path: '/settings/life-balance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsLabelsRoute =
  AuthenticatedSettingsLabelsRouteImport.update({
    id: '/settings/labels',
    path: '/settings/labels',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsCalendarRoute =
  AuthenticatedSettingsCalendarRouteImport.update({
    id: '/settings/calendar',
    path: '/settings/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHabitsNewRoute = AuthenticatedHabitsNewRouteImport.update({
  id: '/habits/new',
  path: '/habits/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGoalsCreateRoute =
  AuthenticatedGoalsCreateRouteImport.update({
    id: '/goals/create',
    path: '/goals/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsLabIndexRoute =
  AuthenticatedSettingsLabIndexRouteImport.update({
    id: '/settings/lab/',
    path: '/settings/lab/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdIndexRoute =
  AuthenticatedProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsGoalIdIndexRoute =
  AuthenticatedGoalsGoalIdIndexRouteImport.update({
    id: '/goals/$goalId/',
    path: '/goals/$goalId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewFormRoute =
  AuthenticatedTasksNewFormRouteImport.update({
    id: '/tasks/new/form',
    path: '/tasks/new/form',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksTaskIdFocusRoute =
  AuthenticatedTasksTaskIdFocusRouteImport.update({
    id: '/tasks/$taskId/focus',
    path: '/tasks/$taskId/focus',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksTaskIdEditRoute =
  AuthenticatedTasksTaskIdEditRouteImport.update({
    id: '/tasks/$taskId/edit',
    path: '/tasks/$taskId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksTaskIdDetailRoute =
  AuthenticatedTasksTaskIdDetailRouteImport.update({
    id: '/tasks/$taskId/detail',
    path: '/tasks/$taskId/detail',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsNewFormRoute =
  AuthenticatedProjectsNewFormRouteImport.update({
    id: '/projects/new/form',
    path: '/projects/new/form',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdEditRoute =
  AuthenticatedProjectsProjectIdEditRouteImport.update({
    id: '/projects/$projectId/edit',
    path: '/projects/$projectId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalNewFormRoute =
  AuthenticatedJournalNewFormRouteImport.update({
    id: '/journal/new/form',
    path: '/journal/new/form',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalJournalIdEditRoute =
  AuthenticatedJournalJournalIdEditRouteImport.update({
    id: '/journal/$journalId/edit',
    path: '/journal/$journalId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalJournalIdDetailRoute =
  AuthenticatedJournalJournalIdDetailRouteImport.update({
    id: '/journal/$journalId/detail',
    path: '/journal/$journalId/detail',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHabitsHabitIdEditRoute =
  AuthenticatedHabitsHabitIdEditRouteImport.update({
    id: '/habits/$habitId/edit',
    path: '/habits/$habitId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsGoalIdRefineRoute =
  AuthenticatedGoalsGoalIdRefineRouteImport.update({
    id: '/goals/$goalId/refine',
    path: '/goals/$goalId/refine',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarNewFormRoute =
  AuthenticatedCalendarNewFormRouteImport.update({
    id: '/calendar/new/form',
    path: '/calendar/new/form',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarEntryIdEditRoute =
  AuthenticatedCalendarEntryIdEditRouteImport.update({
    id: '/calendar/$entryId/edit',
    path: '/calendar/$entryId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsLabelsLabelIdModalRoute =
  AuthenticatedSettingsLabelsLabelIdModalRouteImport.update({
    id: '/$labelId/modal',
    path: '/$labelId/modal',
    getParentRoute: () => AuthenticatedSettingsLabelsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof UnauthenticatedIndexRoute
  '/googleCalendarAuthError': typeof GoogleCalendarAuthErrorRoute
  '/googleCalendarAuthSuccess': typeof GoogleCalendarAuthSuccessRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/onboarding': typeof UnauthenticatedOnboardingRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/goals/create': typeof AuthenticatedGoalsCreateRoute
  '/habits/new': typeof AuthenticatedHabitsNewRoute
  '/settings/calendar': typeof AuthenticatedSettingsCalendarRoute
  '/settings/labels': typeof AuthenticatedSettingsLabelsRouteWithChildren
  '/settings/life-balance': typeof AuthenticatedSettingsLifeBalanceRoute
  '/settings/life-satisfaction': typeof AuthenticatedSettingsLifeSatisfactionRoute
  '/settings/physical-capacity': typeof AuthenticatedSettingsPhysicalCapacityRoute
  '/settings/week': typeof AuthenticatedSettingsWeekRoute
  '/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/insights/': typeof AuthenticatedInsightsIndexRoute
  '/journal/': typeof AuthenticatedJournalIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/summarizations/': typeof AuthenticatedSummarizationsIndexRoute
  '/tables/': typeof AuthenticatedTablesIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/calendar/$entryId/edit': typeof AuthenticatedCalendarEntryIdEditRoute
  '/calendar/new/form': typeof AuthenticatedCalendarNewFormRoute
  '/goals/$goalId/refine': typeof AuthenticatedGoalsGoalIdRefineRoute
  '/habits/$habitId/edit': typeof AuthenticatedHabitsHabitIdEditRoute
  '/journal/$journalId/detail': typeof AuthenticatedJournalJournalIdDetailRoute
  '/journal/$journalId/edit': typeof AuthenticatedJournalJournalIdEditRoute
  '/journal/new/form': typeof AuthenticatedJournalNewFormRoute
  '/projects/$projectId/edit': typeof AuthenticatedProjectsProjectIdEditRoute
  '/projects/new/form': typeof AuthenticatedProjectsNewFormRoute
  '/tasks/$taskId/detail': typeof AuthenticatedTasksTaskIdDetailRoute
  '/tasks/$taskId/edit': typeof AuthenticatedTasksTaskIdEditRoute
  '/tasks/$taskId/focus': typeof AuthenticatedTasksTaskIdFocusRoute
  '/tasks/new/form': typeof AuthenticatedTasksNewFormRoute
  '/goals/$goalId/': typeof AuthenticatedGoalsGoalIdIndexRoute
  '/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/settings/lab/': typeof AuthenticatedSettingsLabIndexRoute
  '/settings/labels/$labelId/modal': typeof AuthenticatedSettingsLabelsLabelIdModalRoute
}
export interface FileRoutesByTo {
  '/': typeof UnauthenticatedIndexRoute
  '/googleCalendarAuthError': typeof GoogleCalendarAuthErrorRoute
  '/googleCalendarAuthSuccess': typeof GoogleCalendarAuthSuccessRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/onboarding': typeof UnauthenticatedOnboardingRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/goals/create': typeof AuthenticatedGoalsCreateRoute
  '/habits/new': typeof AuthenticatedHabitsNewRoute
  '/settings/calendar': typeof AuthenticatedSettingsCalendarRoute
  '/settings/labels': typeof AuthenticatedSettingsLabelsRouteWithChildren
  '/settings/life-balance': typeof AuthenticatedSettingsLifeBalanceRoute
  '/settings/life-satisfaction': typeof AuthenticatedSettingsLifeSatisfactionRoute
  '/settings/physical-capacity': typeof AuthenticatedSettingsPhysicalCapacityRoute
  '/settings/week': typeof AuthenticatedSettingsWeekRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/insights': typeof AuthenticatedInsightsIndexRoute
  '/journal': typeof AuthenticatedJournalIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/summarizations': typeof AuthenticatedSummarizationsIndexRoute
  '/tables': typeof AuthenticatedTablesIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/calendar/$entryId/edit': typeof AuthenticatedCalendarEntryIdEditRoute
  '/calendar/new/form': typeof AuthenticatedCalendarNewFormRoute
  '/goals/$goalId/refine': typeof AuthenticatedGoalsGoalIdRefineRoute
  '/habits/$habitId/edit': typeof AuthenticatedHabitsHabitIdEditRoute
  '/journal/$journalId/detail': typeof AuthenticatedJournalJournalIdDetailRoute
  '/journal/$journalId/edit': typeof AuthenticatedJournalJournalIdEditRoute
  '/journal/new/form': typeof AuthenticatedJournalNewFormRoute
  '/projects/$projectId/edit': typeof AuthenticatedProjectsProjectIdEditRoute
  '/projects/new/form': typeof AuthenticatedProjectsNewFormRoute
  '/tasks/$taskId/detail': typeof AuthenticatedTasksTaskIdDetailRoute
  '/tasks/$taskId/edit': typeof AuthenticatedTasksTaskIdEditRoute
  '/tasks/$taskId/focus': typeof AuthenticatedTasksTaskIdFocusRoute
  '/tasks/new/form': typeof AuthenticatedTasksNewFormRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdIndexRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/settings/lab': typeof AuthenticatedSettingsLabIndexRoute
  '/settings/labels/$labelId/modal': typeof AuthenticatedSettingsLabelsLabelIdModalRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/googleCalendarAuthError': typeof GoogleCalendarAuthErrorRoute
  '/googleCalendarAuthSuccess': typeof GoogleCalendarAuthSuccessRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/logout': typeof AuthenticatedLogoutRoute
  '/_unauthenticated/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/onboarding': typeof UnauthenticatedOnboardingRoute
  '/_unauthenticated/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/_unauthenticated/': typeof UnauthenticatedIndexRoute
  '/_authenticated/goals/create': typeof AuthenticatedGoalsCreateRoute
  '/_authenticated/habits/new': typeof AuthenticatedHabitsNewRoute
  '/_authenticated/settings/calendar': typeof AuthenticatedSettingsCalendarRoute
  '/_authenticated/settings/labels': typeof AuthenticatedSettingsLabelsRouteWithChildren
  '/_authenticated/settings/life-balance': typeof AuthenticatedSettingsLifeBalanceRoute
  '/_authenticated/settings/life-satisfaction': typeof AuthenticatedSettingsLifeSatisfactionRoute
  '/_authenticated/settings/physical-capacity': typeof AuthenticatedSettingsPhysicalCapacityRoute
  '/_authenticated/settings/week': typeof AuthenticatedSettingsWeekRoute
  '/_authenticated/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/_authenticated/insights/': typeof AuthenticatedInsightsIndexRoute
  '/_authenticated/journal/': typeof AuthenticatedJournalIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/summarizations/': typeof AuthenticatedSummarizationsIndexRoute
  '/_authenticated/tables/': typeof AuthenticatedTablesIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/calendar/$entryId/edit': typeof AuthenticatedCalendarEntryIdEditRoute
  '/_authenticated/calendar/new/form': typeof AuthenticatedCalendarNewFormRoute
  '/_authenticated/goals/$goalId/refine': typeof AuthenticatedGoalsGoalIdRefineRoute
  '/_authenticated/habits/$habitId/edit': typeof AuthenticatedHabitsHabitIdEditRoute
  '/_authenticated/journal/$journalId/detail': typeof AuthenticatedJournalJournalIdDetailRoute
  '/_authenticated/journal/$journalId/edit': typeof AuthenticatedJournalJournalIdEditRoute
  '/_authenticated/journal/new/form': typeof AuthenticatedJournalNewFormRoute
  '/_authenticated/projects/$projectId/edit': typeof AuthenticatedProjectsProjectIdEditRoute
  '/_authenticated/projects/new/form': typeof AuthenticatedProjectsNewFormRoute
  '/_authenticated/tasks/$taskId/detail': typeof AuthenticatedTasksTaskIdDetailRoute
  '/_authenticated/tasks/$taskId/edit': typeof AuthenticatedTasksTaskIdEditRoute
  '/_authenticated/tasks/$taskId/focus': typeof AuthenticatedTasksTaskIdFocusRoute
  '/_authenticated/tasks/new/form': typeof AuthenticatedTasksNewFormRoute
  '/_authenticated/goals/$goalId/': typeof AuthenticatedGoalsGoalIdIndexRoute
  '/_authenticated/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/_authenticated/settings/lab/': typeof AuthenticatedSettingsLabIndexRoute
  '/_authenticated/settings/labels/$labelId/modal': typeof AuthenticatedSettingsLabelsLabelIdModalRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/googleCalendarAuthError'
    | '/googleCalendarAuthSuccess'
    | '/dashboard'
    | '/logout'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/goals/create'
    | '/habits/new'
    | '/settings/calendar'
    | '/settings/labels'
    | '/settings/life-balance'
    | '/settings/life-satisfaction'
    | '/settings/physical-capacity'
    | '/settings/week'
    | '/calendar/'
    | '/insights/'
    | '/journal/'
    | '/projects/'
    | '/settings/'
    | '/summarizations/'
    | '/tables/'
    | '/tasks/'
    | '/calendar/$entryId/edit'
    | '/calendar/new/form'
    | '/goals/$goalId/refine'
    | '/habits/$habitId/edit'
    | '/journal/$journalId/detail'
    | '/journal/$journalId/edit'
    | '/journal/new/form'
    | '/projects/$projectId/edit'
    | '/projects/new/form'
    | '/tasks/$taskId/detail'
    | '/tasks/$taskId/edit'
    | '/tasks/$taskId/focus'
    | '/tasks/new/form'
    | '/goals/$goalId/'
    | '/projects/$projectId/'
    | '/settings/lab/'
    | '/settings/labels/$labelId/modal'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/googleCalendarAuthError'
    | '/googleCalendarAuthSuccess'
    | '/dashboard'
    | '/logout'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/goals/create'
    | '/habits/new'
    | '/settings/calendar'
    | '/settings/labels'
    | '/settings/life-balance'
    | '/settings/life-satisfaction'
    | '/settings/physical-capacity'
    | '/settings/week'
    | '/calendar'
    | '/insights'
    | '/journal'
    | '/projects'
    | '/settings'
    | '/summarizations'
    | '/tables'
    | '/tasks'
    | '/calendar/$entryId/edit'
    | '/calendar/new/form'
    | '/goals/$goalId/refine'
    | '/habits/$habitId/edit'
    | '/journal/$journalId/detail'
    | '/journal/$journalId/edit'
    | '/journal/new/form'
    | '/projects/$projectId/edit'
    | '/projects/new/form'
    | '/tasks/$taskId/detail'
    | '/tasks/$taskId/edit'
    | '/tasks/$taskId/focus'
    | '/tasks/new/form'
    | '/goals/$goalId'
    | '/projects/$projectId'
    | '/settings/lab'
    | '/settings/labels/$labelId/modal'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/googleCalendarAuthError'
    | '/googleCalendarAuthSuccess'
    | '/_authenticated/dashboard'
    | '/_authenticated/logout'
    | '/_unauthenticated/forgot-password'
    | '/_unauthenticated/login'
    | '/_unauthenticated/onboarding'
    | '/_unauthenticated/reset-password'
    | '/_unauthenticated/'
    | '/_authenticated/goals/create'
    | '/_authenticated/habits/new'
    | '/_authenticated/settings/calendar'
    | '/_authenticated/settings/labels'
    | '/_authenticated/settings/life-balance'
    | '/_authenticated/settings/life-satisfaction'
    | '/_authenticated/settings/physical-capacity'
    | '/_authenticated/settings/week'
    | '/_authenticated/calendar/'
    | '/_authenticated/insights/'
    | '/_authenticated/journal/'
    | '/_authenticated/projects/'
    | '/_authenticated/settings/'
    | '/_authenticated/summarizations/'
    | '/_authenticated/tables/'
    | '/_authenticated/tasks/'
    | '/_authenticated/calendar/$entryId/edit'
    | '/_authenticated/calendar/new/form'
    | '/_authenticated/goals/$goalId/refine'
    | '/_authenticated/habits/$habitId/edit'
    | '/_authenticated/journal/$journalId/detail'
    | '/_authenticated/journal/$journalId/edit'
    | '/_authenticated/journal/new/form'
    | '/_authenticated/projects/$projectId/edit'
    | '/_authenticated/projects/new/form'
    | '/_authenticated/tasks/$taskId/detail'
    | '/_authenticated/tasks/$taskId/edit'
    | '/_authenticated/tasks/$taskId/focus'
    | '/_authenticated/tasks/new/form'
    | '/_authenticated/goals/$goalId/'
    | '/_authenticated/projects/$projectId/'
    | '/_authenticated/settings/lab/'
    | '/_authenticated/settings/labels/$labelId/modal'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  GoogleCalendarAuthErrorRoute: typeof GoogleCalendarAuthErrorRoute
  GoogleCalendarAuthSuccessRoute: typeof GoogleCalendarAuthSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/googleCalendarAuthSuccess': {
      id: '/googleCalendarAuthSuccess'
      path: '/googleCalendarAuthSuccess'
      fullPath: '/googleCalendarAuthSuccess'
      preLoaderRoute: typeof GoogleCalendarAuthSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/googleCalendarAuthError': {
      id: '/googleCalendarAuthError'
      path: '/googleCalendarAuthError'
      fullPath: '/googleCalendarAuthError'
      preLoaderRoute: typeof GoogleCalendarAuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/': {
      id: '/_unauthenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset-password': {
      id: '/_unauthenticated/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthenticatedResetPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/onboarding': {
      id: '/_unauthenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof UnauthenticatedOnboardingRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/forgot-password': {
      id: '/_unauthenticated/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedForgotPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/logout': {
      id: '/_authenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLogoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tables/': {
      id: '/_authenticated/tables/'
      path: '/tables'
      fullPath: '/tables/'
      preLoaderRoute: typeof AuthenticatedTablesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/summarizations/': {
      id: '/_authenticated/summarizations/'
      path: '/summarizations'
      fullPath: '/summarizations/'
      preLoaderRoute: typeof AuthenticatedSummarizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journal/': {
      id: '/_authenticated/journal/'
      path: '/journal'
      fullPath: '/journal/'
      preLoaderRoute: typeof AuthenticatedJournalIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/insights/': {
      id: '/_authenticated/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthenticatedInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/': {
      id: '/_authenticated/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AuthenticatedCalendarIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/week': {
      id: '/_authenticated/settings/week'
      path: '/settings/week'
      fullPath: '/settings/week'
      preLoaderRoute: typeof AuthenticatedSettingsWeekRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/physical-capacity': {
      id: '/_authenticated/settings/physical-capacity'
      path: '/settings/physical-capacity'
      fullPath: '/settings/physical-capacity'
      preLoaderRoute: typeof AuthenticatedSettingsPhysicalCapacityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/life-satisfaction': {
      id: '/_authenticated/settings/life-satisfaction'
      path: '/settings/life-satisfaction'
      fullPath: '/settings/life-satisfaction'
      preLoaderRoute: typeof AuthenticatedSettingsLifeSatisfactionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/life-balance': {
      id: '/_authenticated/settings/life-balance'
      path: '/settings/life-balance'
      fullPath: '/settings/life-balance'
      preLoaderRoute: typeof AuthenticatedSettingsLifeBalanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/labels': {
      id: '/_authenticated/settings/labels'
      path: '/settings/labels'
      fullPath: '/settings/labels'
      preLoaderRoute: typeof AuthenticatedSettingsLabelsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/calendar': {
      id: '/_authenticated/settings/calendar'
      path: '/settings/calendar'
      fullPath: '/settings/calendar'
      preLoaderRoute: typeof AuthenticatedSettingsCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/habits/new': {
      id: '/_authenticated/habits/new'
      path: '/habits/new'
      fullPath: '/habits/new'
      preLoaderRoute: typeof AuthenticatedHabitsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/create': {
      id: '/_authenticated/goals/create'
      path: '/goals/create'
      fullPath: '/goals/create'
      preLoaderRoute: typeof AuthenticatedGoalsCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/lab/': {
      id: '/_authenticated/settings/lab/'
      path: '/settings/lab'
      fullPath: '/settings/lab/'
      preLoaderRoute: typeof AuthenticatedSettingsLabIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/': {
      id: '/_authenticated/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/$goalId/': {
      id: '/_authenticated/goals/$goalId/'
      path: '/goals/$goalId'
      fullPath: '/goals/$goalId/'
      preLoaderRoute: typeof AuthenticatedGoalsGoalIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new/form': {
      id: '/_authenticated/tasks/new/form'
      path: '/tasks/new/form'
      fullPath: '/tasks/new/form'
      preLoaderRoute: typeof AuthenticatedTasksNewFormRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId/focus': {
      id: '/_authenticated/tasks/$taskId/focus'
      path: '/tasks/$taskId/focus'
      fullPath: '/tasks/$taskId/focus'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdFocusRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId/edit': {
      id: '/_authenticated/tasks/$taskId/edit'
      path: '/tasks/$taskId/edit'
      fullPath: '/tasks/$taskId/edit'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId/detail': {
      id: '/_authenticated/tasks/$taskId/detail'
      path: '/tasks/$taskId/detail'
      fullPath: '/tasks/$taskId/detail'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdDetailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/new/form': {
      id: '/_authenticated/projects/new/form'
      path: '/projects/new/form'
      fullPath: '/projects/new/form'
      preLoaderRoute: typeof AuthenticatedProjectsNewFormRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectId/edit': {
      id: '/_authenticated/projects/$projectId/edit'
      path: '/projects/$projectId/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journal/new/form': {
      id: '/_authenticated/journal/new/form'
      path: '/journal/new/form'
      fullPath: '/journal/new/form'
      preLoaderRoute: typeof AuthenticatedJournalNewFormRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journal/$journalId/edit': {
      id: '/_authenticated/journal/$journalId/edit'
      path: '/journal/$journalId/edit'
      fullPath: '/journal/$journalId/edit'
      preLoaderRoute: typeof AuthenticatedJournalJournalIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journal/$journalId/detail': {
      id: '/_authenticated/journal/$journalId/detail'
      path: '/journal/$journalId/detail'
      fullPath: '/journal/$journalId/detail'
      preLoaderRoute: typeof AuthenticatedJournalJournalIdDetailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/habits/$habitId/edit': {
      id: '/_authenticated/habits/$habitId/edit'
      path: '/habits/$habitId/edit'
      fullPath: '/habits/$habitId/edit'
      preLoaderRoute: typeof AuthenticatedHabitsHabitIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/$goalId/refine': {
      id: '/_authenticated/goals/$goalId/refine'
      path: '/goals/$goalId/refine'
      fullPath: '/goals/$goalId/refine'
      preLoaderRoute: typeof AuthenticatedGoalsGoalIdRefineRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/new/form': {
      id: '/_authenticated/calendar/new/form'
      path: '/calendar/new/form'
      fullPath: '/calendar/new/form'
      preLoaderRoute: typeof AuthenticatedCalendarNewFormRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/$entryId/edit': {
      id: '/_authenticated/calendar/$entryId/edit'
      path: '/calendar/$entryId/edit'
      fullPath: '/calendar/$entryId/edit'
      preLoaderRoute: typeof AuthenticatedCalendarEntryIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/labels/$labelId/modal': {
      id: '/_authenticated/settings/labels/$labelId/modal'
      path: '/$labelId/modal'
      fullPath: '/settings/labels/$labelId/modal'
      preLoaderRoute: typeof AuthenticatedSettingsLabelsLabelIdModalRouteImport
      parentRoute: typeof AuthenticatedSettingsLabelsRoute
    }
  }
}

interface AuthenticatedSettingsLabelsRouteChildren {
  AuthenticatedSettingsLabelsLabelIdModalRoute: typeof AuthenticatedSettingsLabelsLabelIdModalRoute
}

const AuthenticatedSettingsLabelsRouteChildren: AuthenticatedSettingsLabelsRouteChildren =
  {
    AuthenticatedSettingsLabelsLabelIdModalRoute:
      AuthenticatedSettingsLabelsLabelIdModalRoute,
  }

const AuthenticatedSettingsLabelsRouteWithChildren =
  AuthenticatedSettingsLabelsRoute._addFileChildren(
    AuthenticatedSettingsLabelsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedLogoutRoute: typeof AuthenticatedLogoutRoute
  AuthenticatedGoalsCreateRoute: typeof AuthenticatedGoalsCreateRoute
  AuthenticatedHabitsNewRoute: typeof AuthenticatedHabitsNewRoute
  AuthenticatedSettingsCalendarRoute: typeof AuthenticatedSettingsCalendarRoute
  AuthenticatedSettingsLabelsRoute: typeof AuthenticatedSettingsLabelsRouteWithChildren
  AuthenticatedSettingsLifeBalanceRoute: typeof AuthenticatedSettingsLifeBalanceRoute
  AuthenticatedSettingsLifeSatisfactionRoute: typeof AuthenticatedSettingsLifeSatisfactionRoute
  AuthenticatedSettingsPhysicalCapacityRoute: typeof AuthenticatedSettingsPhysicalCapacityRoute
  AuthenticatedSettingsWeekRoute: typeof AuthenticatedSettingsWeekRoute
  AuthenticatedCalendarIndexRoute: typeof AuthenticatedCalendarIndexRoute
  AuthenticatedInsightsIndexRoute: typeof AuthenticatedInsightsIndexRoute
  AuthenticatedJournalIndexRoute: typeof AuthenticatedJournalIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSummarizationsIndexRoute: typeof AuthenticatedSummarizationsIndexRoute
  AuthenticatedTablesIndexRoute: typeof AuthenticatedTablesIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedCalendarEntryIdEditRoute: typeof AuthenticatedCalendarEntryIdEditRoute
  AuthenticatedCalendarNewFormRoute: typeof AuthenticatedCalendarNewFormRoute
  AuthenticatedGoalsGoalIdRefineRoute: typeof AuthenticatedGoalsGoalIdRefineRoute
  AuthenticatedHabitsHabitIdEditRoute: typeof AuthenticatedHabitsHabitIdEditRoute
  AuthenticatedJournalJournalIdDetailRoute: typeof AuthenticatedJournalJournalIdDetailRoute
  AuthenticatedJournalJournalIdEditRoute: typeof AuthenticatedJournalJournalIdEditRoute
  AuthenticatedJournalNewFormRoute: typeof AuthenticatedJournalNewFormRoute
  AuthenticatedProjectsProjectIdEditRoute: typeof AuthenticatedProjectsProjectIdEditRoute
  AuthenticatedProjectsNewFormRoute: typeof AuthenticatedProjectsNewFormRoute
  AuthenticatedTasksTaskIdDetailRoute: typeof AuthenticatedTasksTaskIdDetailRoute
  AuthenticatedTasksTaskIdEditRoute: typeof AuthenticatedTasksTaskIdEditRoute
  AuthenticatedTasksTaskIdFocusRoute: typeof AuthenticatedTasksTaskIdFocusRoute
  AuthenticatedTasksNewFormRoute: typeof AuthenticatedTasksNewFormRoute
  AuthenticatedGoalsGoalIdIndexRoute: typeof AuthenticatedGoalsGoalIdIndexRoute
  AuthenticatedProjectsProjectIdIndexRoute: typeof AuthenticatedProjectsProjectIdIndexRoute
  AuthenticatedSettingsLabIndexRoute: typeof AuthenticatedSettingsLabIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedLogoutRoute: AuthenticatedLogoutRoute,
  AuthenticatedGoalsCreateRoute: AuthenticatedGoalsCreateRoute,
  AuthenticatedHabitsNewRoute: AuthenticatedHabitsNewRoute,
  AuthenticatedSettingsCalendarRoute: AuthenticatedSettingsCalendarRoute,
  AuthenticatedSettingsLabelsRoute:
    AuthenticatedSettingsLabelsRouteWithChildren,
  AuthenticatedSettingsLifeBalanceRoute: AuthenticatedSettingsLifeBalanceRoute,
  AuthenticatedSettingsLifeSatisfactionRoute:
    AuthenticatedSettingsLifeSatisfactionRoute,
  AuthenticatedSettingsPhysicalCapacityRoute:
    AuthenticatedSettingsPhysicalCapacityRoute,
  AuthenticatedSettingsWeekRoute: AuthenticatedSettingsWeekRoute,
  AuthenticatedCalendarIndexRoute: AuthenticatedCalendarIndexRoute,
  AuthenticatedInsightsIndexRoute: AuthenticatedInsightsIndexRoute,
  AuthenticatedJournalIndexRoute: AuthenticatedJournalIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSummarizationsIndexRoute: AuthenticatedSummarizationsIndexRoute,
  AuthenticatedTablesIndexRoute: AuthenticatedTablesIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedCalendarEntryIdEditRoute: AuthenticatedCalendarEntryIdEditRoute,
  AuthenticatedCalendarNewFormRoute: AuthenticatedCalendarNewFormRoute,
  AuthenticatedGoalsGoalIdRefineRoute: AuthenticatedGoalsGoalIdRefineRoute,
  AuthenticatedHabitsHabitIdEditRoute: AuthenticatedHabitsHabitIdEditRoute,
  AuthenticatedJournalJournalIdDetailRoute:
    AuthenticatedJournalJournalIdDetailRoute,
  AuthenticatedJournalJournalIdEditRoute:
    AuthenticatedJournalJournalIdEditRoute,
  AuthenticatedJournalNewFormRoute: AuthenticatedJournalNewFormRoute,
  AuthenticatedProjectsProjectIdEditRoute:
    AuthenticatedProjectsProjectIdEditRoute,
  AuthenticatedProjectsNewFormRoute: AuthenticatedProjectsNewFormRoute,
  AuthenticatedTasksTaskIdDetailRoute: AuthenticatedTasksTaskIdDetailRoute,
  AuthenticatedTasksTaskIdEditRoute: AuthenticatedTasksTaskIdEditRoute,
  AuthenticatedTasksTaskIdFocusRoute: AuthenticatedTasksTaskIdFocusRoute,
  AuthenticatedTasksNewFormRoute: AuthenticatedTasksNewFormRoute,
  AuthenticatedGoalsGoalIdIndexRoute: AuthenticatedGoalsGoalIdIndexRoute,
  AuthenticatedProjectsProjectIdIndexRoute:
    AuthenticatedProjectsProjectIdIndexRoute,
  AuthenticatedSettingsLabIndexRoute: AuthenticatedSettingsLabIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedForgotPasswordRoute: typeof UnauthenticatedForgotPasswordRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedOnboardingRoute: typeof UnauthenticatedOnboardingRoute
  UnauthenticatedResetPasswordRoute: typeof UnauthenticatedResetPasswordRoute
  UnauthenticatedIndexRoute: typeof UnauthenticatedIndexRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedForgotPasswordRoute: UnauthenticatedForgotPasswordRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedOnboardingRoute: UnauthenticatedOnboardingRoute,
  UnauthenticatedResetPasswordRoute: UnauthenticatedResetPasswordRoute,
  UnauthenticatedIndexRoute: UnauthenticatedIndexRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  GoogleCalendarAuthErrorRoute: GoogleCalendarAuthErrorRoute,
  GoogleCalendarAuthSuccessRoute: GoogleCalendarAuthSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
